import { BUCKET_NAME, CLOUD_FRONT_URL } from "../conf";

const getImgUrl = (product, width = false, height = false) => {
	const key = product.image_key;

	if (!key) {
		return product.photo_url;
	}

	const imgPayload = JSON.stringify({
		bucket: BUCKET_NAME,
		key,
		edits: {
			resize: {
				width: width || 450,
				height: height || 450,
			},
		},
	});

	return `${CLOUD_FRONT_URL}/${btoa(imgPayload)}`;
};

export default getImgUrl;
